import {rechargeLogList,getAgentInfo} from 'api/rechargeLog';
import Cookies from 'js-cookie';

const rechargeLog = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        rechargeLogList({commit},params) {
            return new Promise((resolve, reject) => {
                var startTime = params.startTime;
                var endTime = params.endTime;
                var accountBegin = params.accountBegin;
                var accountEnd = params.accountEnd;
                var agent = params.agent;
                var productId = params.productId;
                var type = params.type;
                var remark = params.remark;
                var status = params.status;
                var psize = params.psize;
                var currentPage = params.currentPage;
                rechargeLogList(startTime,endTime,accountBegin,accountEnd,agent,productId,type,status,psize,currentPage,remark).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        getAgentInfo({commit}, params) {
            return new Promise((resolve, reject) => {
                getAgentInfo(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
    }
};

export default rechargeLog;



// WEBPACK FOOTER //
// ./src/store/modules/rechargeLog.js